export default "__VITE_ASSET__007f1785__"